import { useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { getPromosToAutoApply, getStalePromoBetIds } from '../utils/promo-criteria/auto-apply-promos';
import { useSbkBetslipPromos } from './use-sbk-betslip-promos';
import { useSbkBetSlipStore } from './use-sbk-betslip-store';

export const useSyncBetslipPromos = () => {
    const { promos, isSuccess } = useSbkBetslipPromos();
    const promosToApply = useSbkBetSlipStore(useShallow(state => getPromosToAutoApply(promos, state)));
    const staleBetIds = useSbkBetSlipStore(useShallow(state => getStalePromoBetIds(promos, state.selectedPromos)));
    const autoApplyPromos = useSbkBetSlipStore(state => state.actions.autoApplyPromos);
    const setSelectedPromo = useSbkBetSlipStore(state => state.actions.setSelectedPromo);

    useEffect(() => {
        if (isSuccess) {
            staleBetIds.forEach(betId => setSelectedPromo(betId, null));
        }
    }, [isSuccess, staleBetIds, setSelectedPromo]);

    useEffect(() => {
        if (Object.keys(promosToApply).length > 0) {
            autoApplyPromos(promosToApply);
        }
    }, [promosToApply, autoApplyPromos]);
};
